export enum AlarmClassTypes {
  MNF = 1,
  DDI = 2,
  DL = 3,
  Flow = 4,
  Pressure = 5,
  Level = 6,
  Others = 7,
}
